export type Base64String = string;

export function base64(i: string): Base64String {
  return Buffer.from(i, 'utf8').toString('base64');
}

export function unbase64(i: Base64String): string {
  return Buffer.from(i, 'base64').toString('utf8');
}

/**
 * Check if string is valid base64 string
 */
export function isBase64ID(str: string): boolean {
  const buffer = Buffer.from(str, 'base64');
  // return false when decoded string has invalid characters that is not part of the global ID format
  return buffer.toString('base64') === str && !/[^a-zA-Z0-9:_]/g.test(buffer.toString('utf8'));
}
